<script lang="ts">
    import { getCachedEntries } from "../../../../api"
    import { users } from "../../../store"
    import TaskFiles from "../../../taskSteps/widgets/TaskFiles.svelte"
    import TaskImages, { getAllTaskImageReferences } from "../../../taskSteps/widgets/TaskImages/TaskImages.svelte"
    import Loader from "../../Loader.svelte"

    export let task: Task
    let modals = {
        showTaskImages: false,
        showTaskFiles: false,
    }
    let author = ""
    $: if (!modals.showTaskImages) author = ""
    const imageReferences = getAllTaskImageReferences(task)

    const editedByUniqueIds = new Set(task?.meta?.editedBy?.map((user) => user.id))
    const editedByUnique = Array.from(editedByUniqueIds).map((id) =>
        task?.meta?.editedBy?.find((user) => user.id === id)
    )
</script>

<ul class="task-edited-by">
    {#each editedByUnique || [] as user}
        <li>
            {#await getCachedEntries( "media", { _id: { $in: Array.from(imageReferences || []) }, "author.id": user.id } )}
                <Loader />
            {:then images}
                <button
                    disabled="{!images.length}"
                    class:active="{!!images.length}"
                    on:click|stopPropagation|preventDefault="{() => {
                        author = user.id
                        modals.showTaskImages = true
                    }}"
                >
                    <img
                        src="../../../../../assets/icons/Group.svg"
                        alt="bild"
                    />
                    <span>{images.length} Fotos ({$users[user.id]?.username})</span>
                </button>
            {/await}
        </li>
    {/each}
    <li>
        <button
            on:click|stopPropagation|preventDefault="{() => {
                modals.showTaskFiles = true
            }}"
        >
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.47 15.47C11.6106 15.3295 11.8012 15.2507 12 15.2507C12.1988 15.2507 12.3894 15.3295 12.53 15.47L14.53 17.47C14.6037 17.5387 14.6628 17.6215 14.7038 17.7135C14.7448 17.8055 14.7668 17.9048 14.7686 18.0055C14.7704 18.1062 14.7518 18.2062 14.7141 18.2996C14.6764 18.393 14.6203 18.4778 14.549 18.549C14.4778 18.6203 14.393 18.6764 14.2996 18.7141C14.2062 18.7518 14.1062 18.7704 14.0055 18.7686C13.9048 18.7668 13.8055 18.7448 13.7135 18.7038C13.6215 18.6628 13.5387 18.6037 13.47 18.53L12.75 17.81V22C12.75 22.1989 12.671 22.3897 12.5303 22.5303C12.3897 22.671 12.1989 22.75 12 22.75C11.8011 22.75 11.6103 22.671 11.4697 22.5303C11.329 22.3897 11.25 22.1989 11.25 22V17.81L10.53 18.53C10.4613 18.6037 10.3785 18.6628 10.2865 18.7038C10.1945 18.7448 10.0952 18.7668 9.99452 18.7686C9.89382 18.7704 9.79379 18.7518 9.7004 18.7141C9.60701 18.6764 9.52218 18.6203 9.45096 18.549C9.37974 18.4778 9.3236 18.393 9.28588 18.2996C9.24816 18.2062 9.22963 18.1062 9.23141 18.0055C9.23319 17.9048 9.25523 17.8055 9.29622 17.7135C9.33721 17.6215 9.39631 17.5387 9.47 17.47L11.47 15.47Z"
                    fill="#6C757D"></path>
                <path
                    d="M12.476 3.75C9.726 3.75 7.512 5.95 7.512 8.647C7.512 9.109 7.577 9.556 7.697 9.978C8.194 10.122 8.66 10.338 9.08 10.618C9.16639 10.6703 9.24132 10.7396 9.3003 10.8216C9.35927 10.9036 9.40108 10.9966 9.4232 11.0952C9.44533 11.1938 9.44732 11.2958 9.42906 11.3951C9.41079 11.4944 9.37265 11.5891 9.31692 11.6733C9.26118 11.7576 9.18901 11.8297 9.10472 11.8853C9.02044 11.941 8.92578 11.9791 8.82642 11.9972C8.72706 12.0154 8.62506 12.0133 8.52652 11.9911C8.42799 11.9689 8.33495 11.927 8.253 11.868C7.66992 11.4817 6.98546 11.2767 6.286 11.279C4.325 11.279 2.75 12.849 2.75 14.765C2.75 16.681 4.325 18.25 6.286 18.25C6.48491 18.25 6.67568 18.329 6.81633 18.4697C6.95698 18.6103 7.036 18.8011 7.036 19C7.036 19.1989 6.95698 19.3897 6.81633 19.5303C6.67568 19.671 6.48491 19.75 6.286 19.75C3.513 19.75 1.25 17.526 1.25 14.765C1.25 12.06 3.42 9.872 6.114 9.782C6.04614 9.40748 6.012 9.02762 6.012 8.647C6.012 5.106 8.914 2.25 12.476 2.25C15.634 2.25 18.272 4.494 18.831 7.471C21.131 8.448 22.75 10.709 22.75 13.353C22.75 16.427 20.562 18.984 17.657 19.606C17.4625 19.6476 17.2594 19.6103 17.0924 19.5022C16.9254 19.3941 16.8081 19.224 16.7665 19.0295C16.7249 18.835 16.7622 18.6319 16.8703 18.4649C16.9784 18.2979 17.1485 18.1806 17.343 18.139C19.583 17.659 21.25 15.693 21.25 13.353C21.25 11.216 19.86 9.391 17.912 8.725C17.3886 8.54599 16.8392 8.45476 16.286 8.455C15.703 8.455 15.146 8.555 14.628 8.735C14.4414 8.79593 14.2383 8.78126 14.0624 8.69415C13.8865 8.60704 13.7517 8.45443 13.6871 8.26909C13.6224 8.08374 13.633 7.88043 13.7166 7.7028C13.8001 7.52516 13.95 7.38737 14.134 7.319C15.1039 6.98042 16.1401 6.87591 17.158 7.014C16.8085 6.05419 16.1712 5.22564 15.3333 4.64147C14.4953 4.0573 13.4975 3.74597 12.476 3.75Z"
                    fill="#6C757D"></path>
            </svg>

            <span>Datei Upload</span></button
        >
    </li>
    <li>
        <button
            on:click|stopPropagation|preventDefault="{() => {
                modals.showTaskImages = true
            }}"
        >
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.47 15.47C11.6106 15.3295 11.8012 15.2507 12 15.2507C12.1988 15.2507 12.3894 15.3295 12.53 15.47L14.53 17.47C14.6037 17.5387 14.6628 17.6215 14.7038 17.7135C14.7448 17.8055 14.7668 17.9048 14.7686 18.0055C14.7704 18.1062 14.7518 18.2062 14.7141 18.2996C14.6764 18.393 14.6203 18.4778 14.549 18.549C14.4778 18.6203 14.393 18.6764 14.2996 18.7141C14.2062 18.7518 14.1062 18.7704 14.0055 18.7686C13.9048 18.7668 13.8055 18.7448 13.7135 18.7038C13.6215 18.6628 13.5387 18.6037 13.47 18.53L12.75 17.81V22C12.75 22.1989 12.671 22.3897 12.5303 22.5303C12.3897 22.671 12.1989 22.75 12 22.75C11.8011 22.75 11.6103 22.671 11.4697 22.5303C11.329 22.3897 11.25 22.1989 11.25 22V17.81L10.53 18.53C10.4613 18.6037 10.3785 18.6628 10.2865 18.7038C10.1945 18.7448 10.0952 18.7668 9.99452 18.7686C9.89382 18.7704 9.79379 18.7518 9.7004 18.7141C9.60701 18.6764 9.52218 18.6203 9.45096 18.549C9.37974 18.4778 9.3236 18.393 9.28588 18.2996C9.24816 18.2062 9.22963 18.1062 9.23141 18.0055C9.23319 17.9048 9.25523 17.8055 9.29622 17.7135C9.33721 17.6215 9.39631 17.5387 9.47 17.47L11.47 15.47Z"
                    fill="#6C757D"></path>
                <path
                    d="M12.476 3.75C9.726 3.75 7.512 5.95 7.512 8.647C7.512 9.109 7.577 9.556 7.697 9.978C8.194 10.122 8.66 10.338 9.08 10.618C9.16639 10.6703 9.24132 10.7396 9.3003 10.8216C9.35927 10.9036 9.40108 10.9966 9.4232 11.0952C9.44533 11.1938 9.44732 11.2958 9.42906 11.3951C9.41079 11.4944 9.37265 11.5891 9.31692 11.6733C9.26118 11.7576 9.18901 11.8297 9.10472 11.8853C9.02044 11.941 8.92578 11.9791 8.82642 11.9972C8.72706 12.0154 8.62506 12.0133 8.52652 11.9911C8.42799 11.9689 8.33495 11.927 8.253 11.868C7.66992 11.4817 6.98546 11.2767 6.286 11.279C4.325 11.279 2.75 12.849 2.75 14.765C2.75 16.681 4.325 18.25 6.286 18.25C6.48491 18.25 6.67568 18.329 6.81633 18.4697C6.95698 18.6103 7.036 18.8011 7.036 19C7.036 19.1989 6.95698 19.3897 6.81633 19.5303C6.67568 19.671 6.48491 19.75 6.286 19.75C3.513 19.75 1.25 17.526 1.25 14.765C1.25 12.06 3.42 9.872 6.114 9.782C6.04614 9.40748 6.012 9.02762 6.012 8.647C6.012 5.106 8.914 2.25 12.476 2.25C15.634 2.25 18.272 4.494 18.831 7.471C21.131 8.448 22.75 10.709 22.75 13.353C22.75 16.427 20.562 18.984 17.657 19.606C17.4625 19.6476 17.2594 19.6103 17.0924 19.5022C16.9254 19.3941 16.8081 19.224 16.7665 19.0295C16.7249 18.835 16.7622 18.6319 16.8703 18.4649C16.9784 18.2979 17.1485 18.1806 17.343 18.139C19.583 17.659 21.25 15.693 21.25 13.353C21.25 11.216 19.86 9.391 17.912 8.725C17.3886 8.54599 16.8392 8.45476 16.286 8.455C15.703 8.455 15.146 8.555 14.628 8.735C14.4414 8.79593 14.2383 8.78126 14.0624 8.69415C13.8865 8.60704 13.7517 8.45443 13.6871 8.26909C13.6224 8.08374 13.633 7.88043 13.7166 7.7028C13.8001 7.52516 13.95 7.38737 14.134 7.319C15.1039 6.98042 16.1401 6.87591 17.158 7.014C16.8085 6.05419 16.1712 5.22564 15.3333 4.64147C14.4953 4.0573 13.4975 3.74597 12.476 3.75Z"
                    fill="#6C757D"></path>
            </svg>

            <span>Foto Upload</span>
        </button>
    </li>
</ul>
<div class="modals">
    {#if modals.showTaskImages}
        <TaskImages
            task="{JSON.parse(JSON.stringify(task))}"
            bind:showModal="{modals.showTaskImages}"
            author="{author}"
        />
    {/if}
    {#if modals.showTaskFiles}
        <TaskFiles
            task="{JSON.parse(JSON.stringify(task))}"
            bind:showModal="{modals.showTaskFiles}"
        />
    {/if}
</div>

<style lang="less">
    ul {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        li,
        li > button {
            font-size: 1rem;
            display: flex;
            align-items: center;
            gap: 0.6rem;
            color: var(--text-100);
        }
    }
    .modals {
        white-space: wrap;
    }
    button:disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }
</style>
